module.exports = __webpack_public_path__ + "img/Batgirl.6e956f8b.svg";